//using the old buyer code here for investor migration
import * as React from "react";
import SelectBuyer from "../../SelectBuyer/SelectBuyer";
import SelectTeam from "../../SelectTeam-new/SelectTeam";
import SelectAgent from "../../SelectAgent/SelectAgent";
import SelectFirm from "../../SelectFirm/SelectFirm";
import SelectInvester from "../../SelectSeller/SelectInvester";

const BuysideAgent = ({data, handleChangeDropdown, handleChangeInput, addNewItem, newFirm, newAgent, newBuyer, viewMode, deleted, isFinancing, isSeniorAgent}) => {
    return (
        <div className="Buyside-agent">
            <div className="Buyside-agent_column">
                {
                    !isFinancing &&
                    // <SelectBuyer
                    //     className="Buyside-agent_column_item"
                    //     isFromProperty
                    //     value={data.buyer_id}
                    //     valueKey="buyer_id"
                    //     label="Investor"
                    //     data={data}
                    //     handleParentChange={handleChangeDropdown}
                    //     withAddNew
                    //     addNewItem={addNewItem}
                    //     viewMode={viewMode}
                    //     deleted={deleted}
                    //     newBuyer={newBuyer}
                    // />
                    <SelectInvester
                        isFromProperty
                        value={data.buyer_id}
                        valueKey="buyer_id"
                        label="Investor"
                        data={data}
                        handleParentChange={handleChangeDropdown}
                        withAddNew
                        addNewItem={addNewItem}
                        viewMode={viewMode}
                        deleted={deleted}
                        newBuyer={newBuyer}
                    />
                }
                <SelectTeam
                    className="Buyside-agent_column_item"
                    isFromProperty
                    value={data.buyer_agent_1}
                    valueKey="buyer_agent_1"
                    percentKey="buyer_agent_1_percent"
                    label="Investor Agent 1"
                    data={data}
                    hasAgentPercent
                    handleParentChange={handleChangeDropdown}
                    handleInputParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <SelectTeam
                    className="Buyside-agent_column_item"
                    isFromProperty
                    value={data.buyer_agent_2}
                    valueKey="buyer_agent_2"
                    percentKey="buyer_agent_2_percent"
                    label="Investor Agent 2"
                    data={data}
                    hasAgentPercent
                    handleParentChange={handleChangeDropdown}
                    handleInputParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                {
                    !isFinancing &&
                    <SelectTeam
                        className="Buyside-agent_column_item"
                        isFromProperty
                        value={data.buyer_agent_3}
                        valueKey="buyer_agent_3"
                        percentKey="buyer_agent_3_percent"
                        label="Investor Agent 3"
                        data={data}
                        hasAgentPercent
                        handleParentChange={handleChangeDropdown}
                        handleInputParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                }
                <SelectAgent
                    className="Buyside-agent_column_item"
                    isFromProperty
                    value={data.buyer_agent_4}
                    valueKey="buyer_agent_4"
                    percentKey="buyer_agent_4_percent"
                    label="Outside Agent"
                    data={data}
                    hasAgentPercent
                    handleParentChange={handleChangeDropdown}
                    handleInputParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    withAddNew
                    addNewItem={addNewItem}
                    newAgent={newAgent}
                />
                <SelectFirm
                    className="Buyside-agent_column_item"
                    isFromProperty
                    value={data.buyer_agent_4_firm}
                    valueKey="buyer_agent_4_firm"
                    label="Investor Agent Company"
                    data={data}
                    handleParentChange={handleChangeDropdown}
                    withAddNew
                    addNewItem={addNewItem}
                    viewMode={viewMode}
                    deleted={deleted}
                    newFirm={newFirm}
                />
            </div>
            <div className="Buyside-agent_column">
                <div className="Buyside-agent_column_item"></div>
                <div className="Buyside-agent_column_item"></div>
                <div className="Buyside-agent_column_item"></div>
                <div className="Buyside-agent_column_item"></div>
            <SelectAgent
                    className="Buyside-agent_column_item"
                    isFromProperty
                    value={data.referring_buyer_agent}
                    valueKey="referring_buyer_agent"
                    percentKey="referring_buyer_agent_percent"
                    label="Referring Agent"
                    data={data}
                    hasAgentPercent
                    handleParentChange={handleChangeDropdown}
                    handleInputParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    withAddNew
                    addNewItem={addNewItem}
                    newAgent={newAgent}
                />                            
                <SelectFirm
                    className="Listing-agent_column_item"
                    isFromProperty
                    value={data.referring_buyer_agent_firm}
                    valueKey="referring_buyer_agent_firm"
                    label="Referring Agent Company"
                    data={data}
                    handleParentChange={handleChangeDropdown}
                    withAddNew={true}
                    addNewItem={addNewItem}
                    viewMode={viewMode}
                    deleted={deleted}
                    newFirm={newFirm}
                />
            </div>
        </div>
    );
};

export default BuysideAgent;